module.exports = __webpack_public_path__ + "static/fiji2-8d580fdf9288376e690b6c60169468f7.png";